// Georgia research sites drawn on the main map's "Georgia" section.
// Static because there is one public county polygon; move to a table if this grows.
// Source: Whitfield County GIS parcel layer (public record, no survey guarantee).
import type { FeatureCollection, Polygon } from 'geojson';

export type GeorgiaSiteProperties = {
  id: string; name: string; parcel: string; county: string; state: string; address: string;
  recorded_acres: number; gis_acres: number; source: string; note: string;
};

export const GEORGIA_SITES: FeatureCollection<Polygon, GeorgiaSiteProperties> = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "id": "whitfield-13-030-01-000",
      "properties": {
        "id": "whitfield-13-030-01-000",
        "name": "Dalton site",
        "parcel": "13-030-01-000",
        "county": "Whitfield",
        "state": "GA",
        "address": "3272 S Dixie Hwy, Dalton",
        "recorded_acres": 328.12,
        "gis_acres": 321.85,
        "source": "Whitfield County GIS parcel layer, union of its three features for the parcel, retrieved 2026-10-19",
        "note": "Screening outline from county GIS, not a survey. The interior ring is a separate 1-acre parcel (13-043-04-000)."
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -84.988289,
              34.701544
            ],
            [
              -84.988097,
              34.701518
            ],
            [
              -84.988011,
              34.701507
            ],
            [
              -84.987654,
              34.701458
            ],
            [
              -84.987583,
              34.70145
            ],
            [
              -84.987757,
              34.701153
            ],
            [
              -84.98778,
              34.70111
            ],
            [
              -84.988063,
              34.700582
            ],
            [
              -84.988052,
              34.700581
            ],
            [
              -84.987666,
              34.700541
            ],
            [
              -84.987626,
              34.700536
            ],
            [
              -84.98782,
              34.700182
            ],
            [
              -84.987286,
              34.699971
            ],
            [
              -84.987324,
              34.699903
            ],
            [
              -84.987378,
              34.699805
            ],
            [
              -84.987877,
              34.699367
            ],
            [
              -84.98798,
              34.69925
            ],
            [
              -84.989389,
              34.699773
            ],
            [
              -84.990111,
              34.698348
            ],
            [
              -84.990701,
              34.698347
            ],
            [
              -84.991329,
              34.698345
            ],
            [
              -84.991797,
              34.698343
            ],
            [
              -84.992217,
              34.698342
            ],
            [
              -84.992548,
              34.698341
            ],
            [
              -84.996251,
              34.698357
            ],
            [
              -84.999326,
              34.698371
            ],
            [
              -84.99917,
              34.69993
            ],
            [
              -84.999032,
              34.701316
            ],
            [
              -84.998879,
              34.70287
            ],
            [
              -84.998627,
              34.702867
            ],
            [
              -84.998612,
              34.703633
            ],
            [
              -84.998577,
              34.704509
            ],
            [
              -84.998581,
              34.705203
            ],
            [
              -84.998583,
              34.705427
            ],
            [
              -84.998585,
              34.705693
            ],
            [
              -84.998586,
              34.705982
            ],
            [
              -84.998588,
              34.706257
            ],
            [
              -84.99859,
              34.706549
            ],
            [
              -84.998592,
              34.706881
            ],
            [
              -84.998594,
              34.707183
            ],
            [
              -84.998596,
              34.707485
            ],
            [
              -84.998598,
              34.707788
            ],
            [
              -84.9986,
              34.708112
            ],
            [
              -84.998604,
              34.708689
            ],
            [
              -84.999013,
              34.708687
            ],
            [
              -84.999092,
              34.708687
            ],
            [
              -84.999114,
              34.709186
            ],
            [
              -84.999162,
              34.710024
            ],
            [
              -84.997916,
              34.710019
            ],
            [
              -84.993969,
              34.710043
            ],
            [
              -84.993213,
              34.710048
            ],
            [
              -84.991935,
              34.710057
            ],
            [
              -84.991567,
              34.710059
            ],
            [
              -84.990928,
              34.710063
            ],
            [
              -84.990614,
              34.710065
            ],
            [
              -84.990486,
              34.710066
            ],
            [
              -84.99,
              34.710069
            ],
            [
              -84.989327,
              34.710073
            ],
            [
              -84.988001,
              34.710082
            ],
            [
              -84.986994,
              34.710088
            ],
            [
              -84.986335,
              34.710093
            ],
            [
              -84.985844,
              34.710096
            ],
            [
              -84.985658,
              34.710097
            ],
            [
              -84.984341,
              34.710103
            ],
            [
              -84.983689,
              34.710107
            ],
            [
              -84.983486,
              34.710108
            ],
            [
              -84.983455,
              34.708792
            ],
            [
              -84.983792,
              34.708217
            ],
            [
              -84.983923,
              34.707995
            ],
            [
              -84.984097,
              34.707698
            ],
            [
              -84.98454,
              34.706944
            ],
            [
              -84.984688,
              34.706692
            ],
            [
              -84.984859,
              34.7064
            ],
            [
              -84.98515,
              34.705906
            ],
            [
              -84.986407,
              34.706356
            ],
            [
              -84.987022,
              34.705332
            ],
            [
              -84.987488,
              34.704555
            ],
            [
              -84.987992,
              34.703716
            ],
            [
              -84.990875,
              34.704185
            ],
            [
              -84.990787,
              34.702336
            ],
            [
              -84.990761,
              34.701791
            ],
            [
              -84.991801,
              34.70213
            ],
            [
              -84.992619,
              34.702383
            ],
            [
              -84.992847,
              34.702459
            ],
            [
              -84.993287,
              34.702607
            ],
            [
              -84.993663,
              34.702737
            ],
            [
              -84.993557,
              34.704039
            ],
            [
              -84.99344,
              34.705484
            ],
            [
              -84.993323,
              34.706936
            ],
            [
              -84.993746,
              34.706946
            ],
            [
              -84.993878,
              34.70544
            ],
            [
              -84.994006,
              34.703988
            ],
            [
              -84.994105,
              34.702846
            ],
            [
              -84.994112,
              34.702838
            ],
            [
              -84.994119,
              34.70283
            ],
            [
              -84.994125,
              34.702819
            ],
            [
              -84.994129,
              34.70281
            ],
            [
              -84.99413,
              34.702798
            ],
            [
              -84.99413,
              34.702788
            ],
            [
              -84.994128,
              34.702779
            ],
            [
              -84.994125,
              34.702771
            ],
            [
              -84.994118,
              34.70276
            ],
            [
              -84.994108,
              34.702749
            ],
            [
              -84.9941,
              34.702742
            ],
            [
              -84.994091,
              34.702737
            ],
            [
              -84.994082,
              34.702733
            ],
            [
              -84.99335,
              34.70248
            ],
            [
              -84.993083,
              34.70239
            ],
            [
              -84.993666,
              34.701117
            ],
            [
              -84.991538,
              34.700464
            ],
            [
              -84.991629,
              34.700241
            ],
            [
              -84.989872,
              34.700041
            ],
            [
              -84.989346,
              34.699981
            ],
            [
              -84.989128,
              34.699956
            ],
            [
              -84.98897,
              34.700217
            ],
            [
              -84.988929,
              34.700309
            ],
            [
              -84.988789,
              34.70057
            ],
            [
              -84.988768,
              34.700648
            ],
            [
              -84.990295,
              34.700759
            ],
            [
              -84.99025,
              34.700927
            ],
            [
              -84.990082,
              34.701546
            ],
            [
              -84.990022,
              34.70155
            ],
            [
              -84.989909,
              34.701561
            ],
            [
              -84.989779,
              34.701577
            ],
            [
              -84.989677,
              34.701585
            ],
            [
              -84.989528,
              34.701596
            ],
            [
              -84.989406,
              34.701604
            ],
            [
              -84.989236,
              34.701608
            ],
            [
              -84.989095,
              34.701607
            ],
            [
              -84.988928,
              34.7016
            ],
            [
              -84.988737,
              34.701589
            ],
            [
              -84.988532,
              34.701573
            ],
            [
              -84.988289,
              34.701544
            ]
          ],
          [
            [
              -84.99485,
              34.702397
            ],
            [
              -84.994587,
              34.702918
            ],
            [
              -84.995202,
              34.703135
            ],
            [
              -84.995471,
              34.702612
            ],
            [
              -84.99485,
              34.702397
            ]
          ]
        ]
      }
    }
  ]
};

// Parcel centroid, for the section's zoom-to action.
export const GEORGIA_SITE_CENTER: [number, number] = [-84.992748, 34.704959];

// Extent that holds the parcel and the three nearest interstate gas corridors
// (SNG branch/loop, ETNG 3500-1, Transco Dalton Lateral terminus): w, s, e, n.
export const GEORGIA_SITE_BOUNDS: [number, number, number, number] = [-85.035, 34.655, -84.895, 34.76];
